/* eslint-disable react/require-default-props */
import { ReactNode, ReactElement } from 'react';

import styles from './Button.module.scss';

interface iButton {
  children?: ReactNode;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  color?: 'blue' | 'white' | 'grey' | 'transparent';
  size?: 'small' | 'medium' | 'small_medium';
  className?: string;
  isDisabled?: boolean;
}

const Button = ({
  onClick,
  color = 'blue',
  children = null,
  size = 'medium',
  className = '',
  isDisabled = false
}: iButton): ReactElement => (
  <button onClick={onClick} type="button" disabled={isDisabled} className={`${styles.button} ${styles[color!]} ${styles[size!]} ${className}`}>
    {children}
  </button>
);

export default Button;
